import { QueryClientProvider } from '@tanstack/react-query'
import { useEffect, type ReactNode } from 'react'
import { LocaleSync, useT } from '@/shared/i18n'
import { ServicesProvider, type AppServices } from '@/shared/services'
import { ThemeSync, Toaster, TooltipProvider } from '@/shared/ui'

/** All application-wide providers, in dependency order. */
export function AppProviders({
  services,
  children,
}: {
  services: AppServices
  children: ReactNode
}) {
  return (
    <ServicesProvider services={services}>
      <QueryClientProvider client={services.queryClient}>
        <TooltipProvider delayDuration={300}>
          <LocaleSync />
          <ThemeSync />
          <RealtimeLifecycle services={services} />
          {children}
          <Notifications />
        </TooltipProvider>
      </QueryClientProvider>
    </ServicesProvider>
  )
}

/** The notification area of the whole application, with its texts in the user's language. */
function Notifications() {
  const t = useT()
  return (
    <Toaster labels={{ region: t('notifications.region'), dismiss: t('notifications.dismiss') }} />
  )
}

function RealtimeLifecycle({ services }: { services: AppServices }) {
  useEffect(() => {
    services.realtime.connect()
    return () => {
      services.realtime.disconnect()
    }
  }, [services.realtime])
  return null
}
